import React from 'react';
import { PureComponent } from '../../../dispatcher/modules';
import HBox from '../container/h_box/HBox';
import { PUZZLE_TOOLBAR_PROPS } from './Types';

class PuzzleToolbar extends PureComponent<PUZZLE_TOOLBAR_PROPS, {}> {
  static defaultProps = {
    gap: 2
  }
  render() {
    const { children, className, gap = 2 } = this.props;
    return (
      <HBox 
        className={`tp-toolbar ${className}`}
        wrap
        gap={gap}
      >{children}</HBox>
    );
  }
}

export default PuzzleToolbar;
